import React from 'react';
import Skeleton from './Skeleton';
import './VideoCardSkeleton.scss';

interface VideoCardSkeletonProps {
  count?: number;
  className?: string;
}

const VideoCardSkeleton: React.FC<VideoCardSkeletonProps> = ({
  count = 1,
  className = ''
}) => {
  const renderSkeletonCard = () => (
    <div className={`video-card-skeleton ${className}`}>
      {/* 视频缩略图骨架 */}
      <div className="video-thumbnail-skeleton">
        <Skeleton 
          width="100%" 
          height="140px" 
          variant="rectangular"
          animation="wave"
        />
        
        {/* 播放按钮骨架 */}
        <div className="play-icon-skeleton">
          <Skeleton 
            width="50px" 
            height="50px" 
            variant="circular"
            animation="pulse"
          />
        </div>
        
        {/* 时长标签骨架 */}
        <div className="duration-skeleton">
          <Skeleton 
            width="60px" 
            height="24px" 
            variant="rectangular"
            animation="pulse"
          />
        </div>
        
        {/* 状态标签骨架 */}
        <div className="status-skeleton">
          <Skeleton 
            width="53px" 
            height="25px" 
            variant="rectangular"
            animation="pulse"
          />
        </div>
      </div>

      {/* 视频名称骨架 */}
      <div className="video-name-skeleton">
        <Skeleton 
          width="80%" 
          height="16px" 
          variant="text"
          animation="wave"
        />
      </div>

      {/* 创建时间骨架 */}
      <div className="video-time-skeleton">
        <Skeleton 
          width="60%" 
          height="12px" 
          variant="text"
          animation="pulse"
        />
      </div>

      {/* 操作按钮骨架 */}
      <div className="video-actions-skeleton">
        <Skeleton 
          width="28px" 
          height="28px" 
          variant="circular"
          animation="pulse"
        />
        <Skeleton 
          width="28px" 
          height="28px" 
          variant="circular"
          animation="pulse"
        />
      </div>
    </div>
  );

  if (count === 1) {
    return renderSkeletonCard();
  }

  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <React.Fragment key={index}>
          {renderSkeletonCard()}
        </React.Fragment>
      ))}
    </>
  );
};

export default VideoCardSkeleton;
